import { createTheme } from "@mui/material/styles";
import { overrideComponents } from "./overrideComponents/components";

// A custom theme for this app
export let theme = createTheme({
  spacing: 6, // 8 is default
  palette: {
    mode: 'light',
    primary: {
      main: "#08519c", // logo color: #0d628d
      light: "#1e78df",
      dark: "#08519c",
    },
    info: {
      main: "#fff"
    },
    text: {
      primary: "#000000" // Black
    },
    dashboardTabs: {
      blue: '#1976D2',
      red: '#D32F2F',
      yellow: '#FBC02D',
      green: '#388E3C',
      purple: '#7B1FA2',
    },
    success: {
      main: '#1DB954',
      light: '#81c784',
      dark: '#388e3c',
    },
    background: {
      default: "rgb(242, 245, 249)",
      //neutral: "#fdfdfd",
      //hover: 'rgba(13, 98, 141, 0.04)'
    },
    border: {
      main: "rgba(0, 0, 0, 0.08)",
      light: "#F5F5F5", // use hex values, not arbitrary color names
      dark: "#cfcfcf",
    },
    shadow: {
      primaryGlow: `0 3px 8px rgba(8, 81, 156, 0.3), 0 0 8px rgba(8, 81, 156, 0.3), 0 0 16px rgba(8, 81, 156, 0.2)`,
      elevatedCard: `0px 4px 20px rgba(0, 0, 0, 0.1)`,
    },
  },
  zIndex: {},
});

declare module "@mui/material/styles" {
  interface Palette {
    border: {
      main: string;
      light: string;
      dark: string;
    };
    shadow: { primaryGlow: string; elevatedCard: string; };
    dashboardTabs: {
      blue: string;
      red: string;
      yellow: string;
      green: string;
      purple: string;
    };
  }
  interface PaletteOptions {
    border: {
      main: string;
      light: string;
      dark: string;
    };
    shadow: { primaryGlow: string; elevatedCard: string; };
    dashboardTabs: {
      blue: string;
      red: string;
      yellow: string;
      green: string;
      purple: string;
    };
  }
  // interface TypeBackground {
  //   neutral: string;
  // }
}

theme.components = overrideComponents(theme);